import { getImageFromS3 } from '../../../imageService';

// Motivational screensaver challenge (Marlboro)
// A/Б/В/Г quiz: the most frequently chosen letter determines the result.
// answerId format: <questionId>.<optionIndex> where optionIndex 1=А, 2=Б, 3=В, 4=Г.
// Result mapping: А -> result1, Б -> result2, В -> result3, Г -> result4.

export const challengeComponent = [
  {
    id: 'motivational-screensaver',
    title: 'Мотиваційна заставка',
    description: 'Ціль, яку бачиш щодня, здійснюється швидше.',
    subDescription:
      'Отримай мотиваційну заставку, що надихатиме на нові звершення.',
    startButtonTitle: 'Пройти тест!',
    backgroundImage: getImageFromS3('images/marlboro/red-background.png'),
    afterResultTitle: 'Уже відчуваєш новий прилив сил?',
    afterResultDescription:
      'Вір у свої кроки — і все заплановане неодмінно здійсниться.',
    questions: [
      {
        id: 1,
        title: 'Я відчуваю найбільший\n поштовх діяти, коли…',
        image: getImageFromS3('images/motivational-screensaver/1.png'),
        answerList: [
          { id: 1.1, title: 'А. Знаю, заради чого працюю' },
          { id: 1.2, title: 'Б. Бачу прогрес' },
          { id: 1.3, title: 'В. Відчуваю відповідальність' },
          { id: 1.4, title: 'Г. Є можливість не поспішати' }
        ]
      },
      {
        id: 2,
        title: 'Найчастіше мене зупиняє…',
        image: getImageFromS3('images/motivational-screensaver/2.png'),
        answerList: [
          { id: 2.1, title: 'А. Страх помилки' },
          { id: 2.2, title: 'Б. Брак часу' },
          { id: 2.3, title: 'В. Відсутність дедлайну' },
          { id: 2.4, title: 'Г. Сумнів' }
        ]
      },
      {
        id: 3,
        title: 'Я рухаюся вперед\n найкраще, коли…',
        image: getImageFromS3('images/motivational-screensaver/3.png'),
        answerList: [
          { id: 3.1, title: 'А. Маю чіткий план' },
          { id: 3.2, title: 'Б. Дозволяю собі гнучкість' },
          { id: 3.3, title: 'В. Чергую дію і паузу' },
          { id: 3.4, title: 'Г. Не порівнюю себе з іншими' }
        ]
      },
      {
        id: 4,
        title: 'У процесі мені важливо\n пам’ятати, що…',
        image: getImageFromS3('images/motivational-screensaver/4.png'),
        answerList: [
          { id: 4.1, title: 'А. Час є' },
          { id: 4.2, title: 'Б. Регулярність чи ідеальність' },
          { id: 4.3, title: 'В. Мій темп — нормальний' },
          { id: 4.4, title: 'Г. Я маю право змінювати план' }
        ]
      },
      {
        id: 5,
        title: 'Я йду до мети заради…',
        image: getImageFromS3('images/motivational-screensaver/5.png'),
        answerList: [
          { id: 5.1, title: 'А. Життя мрії' },
          { id: 5.2, title: 'Б. Внутрішнього спокою' },
          { id: 5.3, title: 'В. Свободи вибору' },
          { id: 5.4, title: 'Г. Результату, яким пишатимусь' }
        ]
      }
    ],
    resultList: [
      {
        id: 1, // А
        description:
          'Ти з тих, хто бачить велику ціль і не погоджується на менше. Твій драйв — це бачити, як ідея стає реальністю. Нехай ця заставка нагадує: ти можеш досягти найвищих вершин.',
        image: getImageFromS3('images/motivational-screensaver/result1.png'),
        screensaver: getImageFromS3(
          'images/motivational-screensaver/screensaver1.png'
        )
      },
      {
        id: 2, // Б
        description:
          'Ти знаєш, що великі зміни створюються щоденними кроками. Твоя суперсила — у вмінні продовжувати навіть тоді, коли зникає натхнення. Тримай заставку, що підтримуватиме тебе щодня.',
        image: getImageFromS3('images/motivational-screensaver/result2.png'),
        screensaver: getImageFromS3(
          'images/motivational-screensaver/screensaver2.png'
        )
      },
      {
        id: 3, // В
        description:
          'Ти цінуєш глибину та вмієш відсікати зайве. Тобі важливо чути себе, а не гамір довкола, і рухатися у власному ритмі. Ця заставка допоможе тобі краще тримати концентрацію.',
        image: getImageFromS3('images/motivational-screensaver/result3.png'),
        screensaver: getImageFromS3(
          'images/motivational-screensaver/screensaver3.png'
        )
      },
      {
        id: 4, // Г
        description:
          'Ти розумієш, що шлях не менш важливий за фініш. Твій талант — знаходити баланс і не відкладати щастя на потім. Ця заставка нагадує про цінність теперішнього.',
        image: getImageFromS3('images/motivational-screensaver/result4.png'),
        screensaver: getImageFromS3(
          'images/motivational-screensaver/screensaver4.png'
        )
      }
    ]
  }
];
